
import { getStudentInfo, updateStudentInfo } from '@/api/myInformation/index'
import { getSchoolStudentInfo as getStudentInfoH5 } from '@/api/h5/myOrder/index'
const userInfoStore = () => {
    const userInfo = ref({})
    const getUserInfo = () => {
        return new Promise((resolve, reject) => {
            let api = getStudentInfo
            if (location.href.indexOf('/h5') > -1) {
                api = getStudentInfoH5
            }
            api().then(res => {
                userInfo.value = { ...res.data } || {};
                resolve({ ...res.data })
            }).catch((error) => {
                reject(error)
            })
        })
    }
    return {
        userInfo,
        getUserInfo
    }
}

export const useUserInfoStore = defineStore('UserInfoStore', userInfoStore, {
    persist: {
        enabled: true,
        storage: localStorage
    }
})
